(function(){

  // ────────── theme settings via Liquid ──────────
  var POINTS_PER_POUND = 4;
  var BONUS_POINTS     = 50;

  // ────────── loyalty math helpers ──────────
  // base: floor(£ * points_per_pound)
  function calculateBasePoints(cents) {
    return Math.floor((cents / 100) * POINTS_PER_POUND);
  }
  // subscription: base + one-off bonus
  function calculateSubscriptionPoints(cents) {
    return calculateBasePoints(cents) + BONUS_POINTS;
  }

  // ────────── currency formatter ──────────
  function formatGBP(cents) {
    return '£' + (cents / 100).toFixed(2);
  }

  window.createSubscriptionModifier = function(data) {

    // 1) clone template
    var tpl = document.getElementById('subscription-modifier-template');
    if (!tpl) {
      console.error('❌ Template not found');
      console.groupEnd();
      return document.createTextNode('Error');
    }
    var root = tpl.content.cloneNode(true).firstElementChild;

    // 2) grab elements
    var idInput      = root.querySelector('#line-item-key-input');
    var qtyInput     = root.querySelector('#line-item-qty-input');
    var planInput    = root.querySelector('#selling-plan-input');
    var freqWrap     = root.querySelector('#frequency-wrap');
    var subBlock     = root.querySelector('[data-role="subscribe-block"]');
    var oneBlock     = root.querySelector('[data-role="onetime-block"]');
    var strikeEl     = root.querySelector('#strike-price');
    var saleEl       = root.querySelector('#subscribe-price');
    var discountEl   = root.querySelector('#discount-label');
    var pointsEl     = root.querySelector('#points-line');
    var oneTimePrice = root.querySelector('#onetime-price');
    var oneTimePts   = root.querySelector('#onetime-points');

    if (![idInput, qtyInput, planInput, freqWrap, subBlock, oneBlock, strikeEl, saleEl, discountEl, pointsEl, oneTimePrice, oneTimePts]
         .every(Boolean)) {
      console.error('❌ Missing one of the required elements');
      console.groupEnd();
      return root;
    }

    // 3) seed hidden inputs
    idInput.value  = data.line_item_key;
    qtyInput.value = data.quantity || 1;

    // 4) one-time block (always use full price)
    var original = data.original_price;
    oneTimePrice.textContent = formatGBP(original);
    oneTimePts.textContent   = 'Earn ' + calculateBasePoints(original) + ' points';

    // 5) switchMode handler
    function switchMode(isSub) {
      subBlock.classList.toggle('active', isSub);
      oneBlock.classList.toggle('active', !isSub);
      root.querySelector('#subscribe' ).classList.toggle('open', isSub);
      root.querySelector('#onetime'   ).classList.toggle('open', !isSub);
      if (!isSub) planInput.value = '';
    }
    subBlock.addEventListener('click', function(){ switchMode(true); });
    oneBlock.addEventListener('click', function(){ switchMode(false); });
    switchMode(true);

    // 6) helper to render header bullet and prices
    function renderHeader(plan) {
      // prices
      strikeEl.textContent   = formatGBP(original);
      saleEl.textContent     = formatGBP(plan.discounted_price);
      discountEl.textContent = plan.value + '%';

      // points line
      var basePts  = calculateBasePoints(plan.discounted_price);
      var totalPts = calculateSubscriptionPoints(plan.discounted_price);
      pointsEl.textContent =
        'Earn ' + totalPts + ' points then ' + basePts + ' every ' + plan.interval;
    }

    // 7) build pills
    data.selling_plans.forEach(function(plan){
      var pill = document.createElement('div');
      pill.className   = 'frequency-option';
      pill.textContent = plan.interval;
      pill.dataset.id  = plan.id;

      pill.addEventListener('click', function(){
        // highlight
        freqWrap.querySelectorAll('.frequency-option').forEach(function(o){
          o.classList.remove('active');
        });
        pill.classList.add('active');

        // write plan id
        planInput.value = plan.id;

        // re-render header
        renderHeader(plan);
      });

      freqWrap.appendChild(pill);
    });

    // 8) auto-select existing or first
    var pills = Array.from(freqWrap.querySelectorAll('.frequency-option'));
    var found = pills.find(function(p){ return p.dataset.id === data.selected_plan_id; });
    (found || pills[0]).click();

    // 9) bind form submit (UPDATED: use cart:refresh instead of full reload)
    var form = root.tagName === 'FORM' ? root : root.querySelector('form');
    if (form) {
      form.addEventListener('submit', function(e){
        e.preventDefault();
        var payload = {
          id:           idInput.value,
          quantity:     qtyInput.value,
          selling_plan: planInput.value
        };
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        })
        .then(function(res){
          if (!res.ok) throw new Error('Cart update failed');
          return res.json();
        })
        .then(function(cart){
          // 🚀 Ask the theme to refresh its cart UI instead of reloading the page
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
          }));

          // If you want to automatically open the mini-cart, uncomment the line below
          // document.documentElement.dispatchEvent(new CustomEvent('cart:drawer:open', { bubbles: true }));
        })
        .catch(function(err){
          console.error('🔴 Cart update failed – falling back to full reload', err);
          window.location.reload();
        });
      });
    }

    console.groupEnd();
    return root;
  };

  // delegated click handler remains the same…
  document.body.addEventListener('click', function(e){
    var btn = e.target.closest('[data-debug]');
    if (!btn) return;
    try {
      var data = JSON.parse(btn.getAttribute('data-debug'));
      var container = document.getElementById('subscription-selector-container');
      if (container) {
        container.innerHTML = '';
        container.appendChild(window.createSubscriptionModifier(data));
      }
    } catch(err){
      console.error('🔴 subscription-modifier data parse error', err);
    }
  });
})();